import { makeAutoObservable } from "mobx";
import { Pricing } from "../Model/pricing";
import axios from "axios";
import { auth } from "../firebase";

class AccoutingStore {
  pricingModels: Pricing[];
  storeId: string | null = null; //TODO_SAT
  constructor() {
    makeAutoObservable(this);
    this.pricingModels = [];
    this.loadPricings();
  }

  public loadPricings(
    storeId: string = "317f6c74-02a6-11f0-962e-0a67fa16b369",
  ) {
    this.storeId = storeId;
    axios
      .get(
        `https://wallof-backend.uc.r.appspot.com/accounting/pricing/${this.storeId}`,
      )
      .then((v) => {
        const data = v.data;
        const pricings = (data as unknown as any)["data"] as Pricing[];
        this.pricingModels = pricings;
        console.log(pricings);
      })
      .catch((e) => {
        console.error("Failed to load pricings due to: ", e);
      });
  }
}

const accountingStore = new AccoutingStore();
export { accountingStore };
